import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mrf-approval',
  templateUrl: './mrf-approval.component.html',
  styleUrls: ['./mrf-approval.component.scss']
})
export class MrfApprovalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
